<template>
  <section id="tools-section">
    <h1 class="title">{{$resx('WebmasterToolsText')}}</h1>
    <h2 class="subtitle">{{$resx('WebmasterToolsSubTitleText')}}</h2>
    <header v-html="$resx('WebmasterToolsHeaderText')"></header>
    <div>
      <div>
        <h2>{{$resx('WidgetLangText')}}</h2>
        <select v-model="model.lang">
          <option v-for="lang in languages" :value="lang.key" :key="lang.key">{{lang.key}}</option>
        </select>
      </div>
      <div>
        <h2>{{$resx('WidgetFormatText')}}</h2>
        <select v-model="model.format">
          <option value="152_152" selected="selected">152_152</option>
          <option value="200_75">200_75</option>
          <option value="320_180">320_180</option>
          <option value="336_280">336_280</option>
          <option value="640_48">640_48</option>
        </select>
      </div>
      <div>
        <h2 v-html="$resx('WidgetTransparentBackgroundText')"></h2>
        <select v-model="model.transparentBg">
          <option :value="true">{{$resx('YesText')}}</option>
          <option :value="false">{{$resx('NoText')}}</option>
        </select>
      </div>
      <div>
        <h2>{{$resx('WidgetAllowBacklinkText')}}</h2>
        <select v-model="model.backLink">
          <option :value="true">{{$resx('YesText')}}</option>
          <option :value="false">{{$resx('NoText')}}</option>
        </select>
      </div>
      <div style="margin:auto">
        <h2>{{$resx('WidgetRenderText')}}</h2>
        <div id="widget-luxe-container" :class="{'bg' : this.model.transparentBg}"></div>
      </div>
      <div>
        <h2>{{$resx('WidgetHTMLCodeText')}}</h2>
        <pre><code id="code">&lt;div id="widget-luxe-container"&gt;
    &lt;script async src="{{widgetUrl}}"&gt;&lt;/script&gt;
&lt;/div&gt;</code><button class="copy btn btn-secondary" @click="copyToClipboard">{{$resx('CopyText')}}</button></pre>
      </div>
    </div>
  </section>
</template>
<script>
import toolsServices from '../services/toolsServices'

export default {
  data () {
    return {
      isLoading: false,
      model: {
        lang: 'fr',
        format: '152_152',
        transparentBg: true,
        backLink: true
      },
      languages: []
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },
    // langue actuellement sélectionnée
    language () {
      return this.$store.state.app.language
    },
    // site selectionné depuis la dropdown
    website () {
      let website = ''
      if (this.languages.length > 0) {
        var self = this
        this.languages.forEach(function (elt) {
          if (elt.key === self.model.lang) {
            website = elt.value
          }
        })
      }
      return website
    },
    widgetUrl () {
      var url = this.website + 'Handlers/Widget?locid=' + this.currentCampingId + '&format=' + this.model.format
      if (this.model.transparentBg) {
        url += '&transparentbg=true'
      }
      if (!this.model.backLink) {
        url += '&backlink=false'
      }
      return url
    }
  },
  watch: {
    widgetUrl: function () {
      this.onUrlChanged()
    }
  },
  methods: {
    async loadLanguages () {
      this.languages = await toolsServices.getLanguageOptions()
    },

    copyToClipboard () {
      var code = document.getElementById('code')
      var input = document.createElement('input')
      input.type = 'text'
      input.value = code.innerText
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$store.commit('app/showSnack', { type: 'succes', message: this.$resx('WidgetHtlmCodeCopiedText') })
    },

    onUrlChanged () {
      var container = document.getElementById('widget-luxe-container')
      // on vide le conteneur
      container.innerHTML = ''
      // on joute le nouveau script
      const script = document.createElement('script')
      script.setAttribute('src', this.widgetUrl)
      container.appendChild(script)
    }
  },
  async mounted () {
    this.$store.commit('app/setPage', 'webmastertools')
    await this.loadLanguages()
    this.model.lang = this.language
    this.onUrlChanged()
  }
}
</script>
<style lang="less">
  #tools-section{

    header
    {
      p
      {
        max-width: 60em;
        margin: 2em auto;
        color: #212121;
        text-align: center;
      }
    }

  h2 {
    color: #9e9e9e;
    margin: 1em 0 .25em 0;

    small{
      font-size:.75em;
      display:block;
    }
  }

  #widget-luxe-container{
    &.bg
    {
      background-color: #d3d3d3;
    }
  }

  pre {
    position: relative;
    overflow: auto;
    -ms-word-wrap: break-word;
    word-wrap: break-word;
    white-space: pre-wrap;
    background-color: #3f3f3f;
    width: 100%;
    padding: 1em;
    margin: 0 0 1em 0;

    code
    {
      text-align: left;
      color: #fff;
      width: 100%;
    }

    .copy {
      position: absolute;
      right: 1em;
      bottom: 1em;
    }
  }
  }
</style>
